// extracted by mini-css-extract-plugin
var _1 = "InhabitantsStatisticModal-modulecontent__vneIF";
var _2 = "InhabitantsStatisticModal-moduleloader__r0kDd";
var _3 = "InhabitantsStatisticModal-modulenotification__g6aEJ";
export { _1 as "content", _2 as "loader", _3 as "notification" }
